import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { getPDF } from "store/swList/swListActions";
import { showErrorToast, showInfoToast } from "store/toast/toastActions";
import useSelector from "store/useSelector";

interface IDownloadLatestPdfVersion {

}

const DownloadLatestPdfVersion: React.FC<IDownloadLatestPdfVersion> = (props) => {
    const {swId: idFromParams} = useParams()
    const swId = window.decodeURIComponent(idFromParams!);
    const dispatch = useDispatch();
    const {
        getPDFData: {
            getPdfOperation,
        }
    } = useSelector(store => store.swList);

    useEffect(() => {
        dispatch(
            getPDF({
                swId,
                generateDefault: true,
                getLatestVersion: true,
            })
        );
    }, [swId, dispatch]);

    if (getPdfOperation?.errorMessage) {
        dispatch(showErrorToast("Error getting PDF"));
    } else if (getPdfOperation?.wasSuccessful) {
        dispatch(showInfoToast("PDF generated & downloaded successfully"));
    }

    return <></>;
}

export default DownloadLatestPdfVersion;